import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

export default function DeleteDialogEvaluation({
  open,
  setOpen,
  deleteFunction,
  id,
  setRefresh,
  setOpenMessage,
  setMessage,
  setSeverity,
}) {
  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseDelete = async () => {
    await deleteFunction(id);
    setMessage("Avaliação excluída com sucesso");
    setSeverity("success");
    setOpenMessage(true);
    setRefresh(true);
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Excluir item"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Você realmente deseja excluir a avaliação permanentemente?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Não
          </Button>
          <Button onClick={handleCloseDelete} color="primary" autoFocus>
            Sim
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
